import React, { useEffect, useRef, useState, } from 'react';
import { Dimensions, Keyboard, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { Typography } from '../../typography/Typography';
import { Button } from '../../button/Button';
import { Header } from '../../header/Header';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import TextField from '../TextField';
import { DropdownInput } from '../../dropDownInput/DropDownBaseInput';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
export var EDUCATION;
(function (EDUCATION) {
    EDUCATION["DIPLOMA"] = "DIPLOMA";
    EDUCATION["POST_GRADUATE"] = "POST_GRADUATE";
    EDUCATION["UNDER_GRADUATE"] = "UNDER_GRADUATE";
    EDUCATION["UP_TO_12"] = "UP_TO_12";
    EDUCATION["MBA"] = "MBA";
    EDUCATION["PHD"] = "PHD";
    EDUCATION["PROFESSIONAL"] = "PROFESSIONAL";
    EDUCATION["OTHERS"] = "OTHERS";
})(EDUCATION || (EDUCATION = {}));
const CoBorrowerAdditionalDetails = ({ stepperData, triggerAction, applyAction, height, qualification, backAction, userName, showVerticalScroll }) => {
    const [userQualification, setQualification] = useState("");
    const [buttonActive, setButtonActive] = useState(false);
    const [singleChecked, setSingleCheked] = useState(true);
    const [marriedChecked, setMarriedChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [rupeeLottie, setRupeeLottie] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [selectedObject, setSelectedObject] = useState({});
    const [successLottie, setSuccessLottie] = useState('');
    const [mFname, setMfName] = useState('');
    const [mLname, setMlName] = useState('');
    const [fatherName, setFathernName] = useState('');
    const [fatherLastName, setFatherLastName] = useState('');
    const [motherNameDesc, setMotherNameDesc] = useState("Enter joint holder’s mother’s first name & last name");
    const [fatherNameDesc, setFatherNameDesc] = useState("Enter joint holder’s father’s first name & last name");
    const theme = ThemeProvider.getTheme();
    const fontFamilyMapping = theme.fontFamily;
    const colorMapping = theme.colors;
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const data = [
        { label: 'Up to 12', value: EDUCATION.UP_TO_12 },
        { label: 'Diploma', value: EDUCATION.DIPLOMA },
        { label: 'Graduate', value: EDUCATION.UNDER_GRADUATE },
        { label: 'Post graduate', value: EDUCATION.POST_GRADUATE },
        { label: 'MBA', value: EDUCATION.MBA },
        { label: 'PHD', value: EDUCATION.PHD },
        { label: 'Professional', value: EDUCATION.PROFESSIONAL },
        { label: 'Others', value: EDUCATION.OTHERS },
    ];
    const renderRadioButtons = () => {
        return (React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
                    if (marriedChecked) {
                        setSingleCheked(true);
                        setMarriedChecked(false);
                    }
                }, style: { flexDirection: 'row' } },
                React.createElement(Icon, { id: 'rb_coBorrowerKycAdditionalDetails_single', name: singleChecked
                        ? IconTokens.RadioCircleFilled
                        : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XXL }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Typography, { label: 'Single', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 20 })),
            React.createElement(Space, { size: SizeTypeTokens.Size6 }),
            React.createElement(TouchableOpacity, { onPress: () => {
                    if (singleChecked) {
                        setMarriedChecked(true);
                        setSingleCheked(false);
                    }
                }, style: { marginLeft: 40, flexDirection: 'row' } },
                React.createElement(Icon, { id: 'rb_coBorrowerKycAdditionalDetails_married', name: marriedChecked
                        ? IconTokens.RadioCircleFilled
                        : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XXL }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Typography, { label: 'Married', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 20 }))));
    };
    const scrollRef = useRef(null);
    useEffect(() => {
        if (mFname.trim() == "" || mLname.trim() == "" || fatherLastName.trim() == "" || fatherName.trim() == "" || userQualification == "") {
            setButtonActive(false);
        }
        else {
            setButtonActive(true);
        }
    }, [mFname, mLname, fatherLastName, fatherName, userQualification]);
    useEffect(() => {
        console.warn("QUALFICATIO NRECEIV", qualification);
        fetch('https://lottie.host/dc3da369-5394-4cb5-9987-3a8856083e44/vsSFRAuwxF.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setRupeeLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch('https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    const [tempHeight, setTempHeight] = useState(height);
    useEffect(() => {
        const handleKeyboardDidShow = (event) => {
            const extraSpace = 50;
            const keyboardHeight = event.endCoordinates.height || 0;
            const newViewHeight = height - keyboardHeight - extraSpace;
            scrollRef?.current?.scrollToEnd();
            setTempHeight(newViewHeight);
        };
        const handleKeyboardDidHide = () => {
            setTempHeight(height);
        };
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', handleKeyboardDidShow);
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', handleKeyboardDidHide);
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);
    // @ts-ignore
    const renderCoBorrowerContent = () => {
        if (Platform.OS === 'web') {
            return (React.createElement(ScrollView, { contentContainerStyle: { flex: 1, height: height - 100 }, nestedScrollEnabled: true, showsVerticalScrollIndicator: showVerticalScroll }, renderContent()));
        }
        else {
            return (React.createElement(View, { style: { height: (Platform.OS == 'ios' || Platform.OS === 'android') ? tempHeight - 100 : height } },
                React.createElement(ScrollView, { ref: scrollRef, style: [styles.scrollView, {
                            ...Platform.OS !== 'ios' && { height: height - 100 },
                            ...Platform.OS === 'ios' && { flex: 1 }
                        }], nestedScrollEnabled: true, showsVerticalScrollIndicator: showVerticalScroll }, renderContent())));
        }
    };
    const renderContent = () => {
        return (React.createElement(TouchableOpacity, { style: { margin: 16, marginTop: 24 }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    padding: 8,
                    backgroundColor: '#FEF4E6',
                    flexDirection: 'row',
                    alignContent: 'center',
                    borderRadius: 4
                } },
                React.createElement(Typography, { label: "Joint holder: ", fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 16 }),
                React.createElement(Typography, { label: `${userName}`, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 16 })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { label: 'Additional information', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, fontWeight: '700', lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: 'Marital status', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
            React.createElement(View, { style: { marginTop: 12 } }, renderRadioButtons()),
            React.createElement(View, { style: { marginTop: 16 }, nativeID: 'tf_coBorrowerKycAdditionalDetails_qualification' },
                React.createElement(DropdownInput, { label: 'Select qualfication', 
                    // @ts-ignore
                    data: data, height: 180, onValueSelect: (value) => {
                        setQualification(value);
                    } })),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(Typography, { label: "Mother’s name", fontSize: FontSizeTokens.SM, lineHeight: 20, fontFamily: FontFamilyTokens.Inter, fontWeight: "600" })),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 8,
                    width: '100%',
                } },
                React.createElement(View, { style: { flex: 0.5 } },
                    React.createElement(TextField, { nativeID: 'tf_coBorrowerKycAdditionalDetails_motherFirstName', label: "Mother's First Name", holder: "First Name", value: mFname, autoFocus: false, onChangeText: (text) => {
                            setMfName(text);
                        } })),
                React.createElement(View, { style: { flex: 0.5, marginLeft: 12 } },
                    React.createElement(TextField, { nativeID: 'tf_coBorrowerKycAdditionalDetails_motherLastName', label: "Mother's Last Name", holder: "Last Mame", value: mLname, autoFocus: false, onChangeText: (text) => {
                            setMlName(text);
                        } }))),
            React.createElement(View, { style: { flexDirection: 'row', marginTop: 4 } },
                React.createElement(Icon, { name: (mLname && mFname) ? "" : IconTokens.Info, color: ColorTokens.System_Warning }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: (mLname && mFname) ? "" : motherNameDesc, color: ColorTokens.System_Warning, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18 })),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(Typography, { label: "Father’s name", fontSize: FontSizeTokens.SM, lineHeight: 20, fontFamily: FontFamilyTokens.Inter, fontWeight: "600" })),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: 8,
                } },
                React.createElement(View, { style: { flex: 0.5 } },
                    React.createElement(TextField, { nativeID: 'tf_coBorrowerKycAdditionalDetails_fatherFirstName', label: "Father's First Name", holder: "First Name", value: fatherName, autoFocus: false, onChangeText: (text) => {
                            setFathernName(text);
                        } })),
                React.createElement(View, { style: { flex: 0.5, marginLeft: 12 } },
                    React.createElement(TextField, { nativeID: 'tf_coBorrowerKycAdditionalDetails_fatherLastName', label: "Father's Last Name", holder: "Last Name", value: fatherLastName, autoFocus: false, onChangeText: (text) => {
                            setFatherLastName(text);
                        } }))),
            React.createElement(View, { style: { flexDirection: 'row', marginTop: 4 } },
                React.createElement(Icon, { name: (fatherName && fatherLastName) ? "" : IconTokens.Info, color: ColorTokens.System_Warning }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: (fatherName && fatherLastName) ? "" : fatherNameDesc, color: ColorTokens.System_Warning, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18 }))));
    };
    return (React.createElement(View, { style: [styles.container, { height: Platform.OS !== "ios" ? height : height - 15 }] },
        React.createElement(View, { style: styles.header },
            React.createElement(Header, { id: 'bt_coBorrower_goBack', type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: 'Joint holder details', onPress: () => {
                    console.warn("BACK ACTION IS PRESENT", backAction);
                    if (backAction) {
                        triggerAction(backAction);
                    }
                } })),
        renderCoBorrowerContent(),
        React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
        React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
        React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderColor: '#F2F4F7',
                borderTopWidth: 1,
                paddingHorizontal: -16,
                paddingVertical: 8,
                backgroundColor: 'white',
            } },
            React.createElement(View, { style: {
                    alignContent: 'center',
                    alignItems: 'center',
                    marginTop: 8,
                    flexDirection: 'row',
                    justifyContent: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.Secure, size: IconSizeTokens.XS, color: ColorTokens.Secondary_100 }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(Typography, { label: 'Your data is secure with us', fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginTop: 8,
                    marginBottom: 6,
                    paddingBottom: Platform.OS === "ios" ? 12 : 0
                } },
                React.createElement(Button, { id: 'bt_coBorrowerKycAdditionalDetails_continue', type: buttonActive
                        ? ButtonTypeTokens.LargeFilled
                        : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Confirm & continue', onPress: () => {
                        if (applyAction) {
                            const kycObj = {
                                maritalStatus: singleChecked ? "SINGLE" : "MARRIED",
                                qualification: userQualification,
                                fatherFirstName: fatherName,
                                fatherLastName: fatherLastName,
                                motherFirstName: mFname,
                                motherLastName: mLname,
                            };
                            triggerAction({
                                ...applyAction,
                                payload: {
                                    selectedItem: kycObj,
                                },
                            });
                        }
                    } })))));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height,
        marginHorizontal: -16,
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 32
        }
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    scrollView: {
        ...Platform.OS !== 'web' && {
            paddingBottom: 20
        }
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    dropdown: {
        margin: 16,
        height: 50,
        width: 150,
        backgroundColor: '#EEEEEE',
        borderRadius: 22,
        paddingHorizontal: 8,
    },
});
export default CoBorrowerAdditionalDetails;
